import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionExerciseTypeForm from '../../../components/forms/CompetitionExerciseTypeForm';
import { useCompetitionExerciseTypeApi } from '../../../hooks/useCompetitionExerciseTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionExerciseTypeDTO } from '../../../services/apiClient';

const CompetitionExerciseTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCompetitionExerciseTypeApi();
  const [entityData, setEntityData] = useState<CompetitionExerciseTypeDTO | null>(
    null,
  );
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Exercise Types', href: '/admin/competitionexercisetypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CompetitionExerciseType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/competitionexercisetypes');
    } catch (error) {
      console.error('Error updating CompetitionExerciseType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionexercisetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetitionExerciseType.Edit"
    >
        {entityData ? (
          <CompetitionExerciseTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/competitionexercisetypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompetitionExerciseTypeEdit;
